import Skeleton, { SkeletonProps } from "react-loading-skeleton";
import { GlobalStore } from "store/global/GlobalStore";
import { withIsVisible } from "utils/reactUtils";

interface Props {
  isVisible?: boolean;
}

export const SkeletonCircle = withIsVisible(
  (
    props: Partial<
      Omit<SkeletonProps, "baseColor" | "highlightColor" | "circle" | "borderRadius">
    > &
      Props
  ) => {
    const theme = GlobalStore.useState(s => s.theme);

    return (
      <div style={{ width: props.width, height: props.height, lineHeight: 1 }}>
        <Skeleton
          baseColor={theme.theme[600]}
          highlightColor={theme.theme[700]}
          circle={true}
          {...props}
          width="100%"
          height="100%"
        />
      </div>
    );
  }
);

export const SkeletonBlock = withIsVisible(
  (props: Partial<Omit<SkeletonProps, "baseColor" | "highlightColor">> & Props) => {
    const theme = GlobalStore.useState(s => s.theme);

    return (
      <div
        style={{ width: props.width, height: props.height, lineHeight: 1 }}
        className={props.className}
      >
        <Skeleton
          baseColor={theme.theme[600]}
          highlightColor={theme.theme[700]}
          borderRadius={props.borderRadius ?? 3}
          {...props}
          width={"100%"}
          height={"100%"}
        />
      </div>
    );
  }
);
